package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.workplace.WorkplaceDto
import com.evoapps.evoshift.data.dto.workplace.GeoLocationDto
import com.evoapps.evoshift.domain.model.GeoLocation
import com.evoapps.evoshift.domain.model.Workplace
import com.evoapps.evoshift.domain.model.resolveStoredLocation

class WorkplaceMapper(
    private val workplaceSettingsMapper: WorkplaceSettingsMapper
) {

    fun toDomain(dto: WorkplaceDto): Workplace {
        return Workplace(
            id = dto.id,
            ownerId = dto.ownerId,
            name = dto.name,
            address = dto.address,
            location = resolveStoredLocation(dto.location?.toDomain(), dto.geoplace),
            settings = workplaceSettingsMapper.toDomain(dto.settings),
            groupId = dto.groupId?.takeIf { it.isNotBlank() }
        )
    }

    fun toDto(domain: Workplace): WorkplaceDto {
        return WorkplaceDto(
            id = domain.id,
            ownerId = domain.ownerId,
            name = domain.name,
            address = domain.address,
            geoplace = domain.location?.format(),
            settings = workplaceSettingsMapper.toDto(domain.settings),
            location = domain.location?.toDto(),
            groupId = domain.groupId
        )
    }
}

/** Null for numbers out of range (a hand-edited document): no location rather than a crash. */
fun GeoLocationDto.toDomain(): GeoLocation? = GeoLocation.of(latitude, longitude)

fun GeoLocation.toDto(): GeoLocationDto = GeoLocationDto(latitude, longitude)
